//React imports
import React, { useEffect } from "react";

import FooterComponent from "../components/home/FooterComponent.js";
import SolutionComponent from "../components/solutions/SolutionComponent.js";

//Imports assets such as images
import NavBarComponent from "../components/navBar/NavBarComponent.js";
import CashbackComponent from "../components/product/cashback/cashbackComponent";

function ProductsPage() {
  return (
    <div>
      <div className="updated-page-wrapper">
        <NavBarComponent />

        {/* <HeaderComponent page="pricing" /> */}


          <CashbackComponent />



        <FooterComponent />
      </div>
    </div>
  );
}

export default ProductsPage;
